<script>
import { mapGetters } from 'vuex';
import { setTimeout } from 'timers';
import { map } from '../helpers.js';

export default {
    name: 'CloudBubble',
    data: () => {
        return {
            movementDuration: 3000,
            currenPos: { x: 0, y: 0 },
            prio: 1
        }
    },
    props: {
        data: Object,
        depthFactor: Number,
        transitionDuration: Number,
        movementRadius: Number,
    },
    mounted() {
        this.movementDuration = this.getRandomArbitrary(8000, 10000);
        setTimeout(() => {
            this.setRandomPos();
        }, 0)
    },
    methods: {
        setRandomPos() {
            const a = Math.random() * 2 * Math.PI;
            const r = Math.sqrt(Math.random());
            const x = r * Math.cos(a);
            const y = r * Math.sin(a);
            this.currenPos = { x: x, y: y };
            setTimeout(() => {
                this.setRandomPos();
            }, this.movementDuration);
        },
        getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        },
        getCenterStyles() {
            return {
                transform: 'scale('+ this.depthFactor +')',
                opacity: map(0, 1, .3, 1, this.depthFactor),
                transition: 'all ' + this.transitionDuration + 'ms', 
                
            }
        },
        getHaloStyles() {
            return {
                transform: 'scale('+ this.depthFactor +')',
                opacity: map(0, 1, .2, 1, this.depthFactor),
                transition: 'all ' + this.transitionDuration + 'ms', 
                
            }
        },
        getTitleStyles() {
            return {
                transform: 'scale('+ map(0, 1, .33, 1, this.depthFactor) +')',
                opacity: map(0, 1, .75, 1, this.depthFactor),
                transition: 'all ' + this.transitionDuration + 'ms'
            }
        },
        getBubbleClasses() {
            const titleInText = this.title.replace('<br>', '');
            const titleLength = titleInText.length;
            let classList = [];

            if (titleLength < 35)
                classList.push('bubble--large-text');
            else if (titleLength < 60)
                classList.push('bubble--medium-text');
            else
                classList.push('bubble--small-text');
            
            if (this.data.question_categories.length > 0)
                classList.push('bubble--cat-' + this.getCategorySlug(this.data.question_categories[0]));

            return classList;
        },
        getCategorySlug(categoryId) {
            const category = this.allCategories.find(item => item.id === categoryId);
            return category ? category.slug : null;
        },
        onMouseOver() {
            this.$emit('mouseOver', this.data);
        },
        onMouseLeave() {
            this.$emit('mouseLeave', this.data);
        },
        onClick(e) {
            e.preventDefault();
            const splittedRoute = this.$route.path.split('/');
            const currentSlug = splittedRoute[splittedRoute.length - 1];
            if (currentSlug === this.data.slug)
                this.$router.push('/home/' + this.data.slug + '/1');
            else
                this.$router.push('/home/' + this.data.slug);
        },
    },
    computed: {
        ...mapGetters({
            allCategories: 'getAllQuestionCategories',
        }),
        title() {
            let title = this.data.use_title ? this.data.title.rendered : this.data.alt_title;
            return title.replace(/"(.*?)"/g, "«$1»");
        },
    },
};
</script>

<template>
    <article 
        ref="bubble" 
        class="bubble" 
        v-bind:class="getBubbleClasses()" 
        v-bind:style="{ 
            transform: 'translate3d(' + currenPos.x * movementRadius * depthFactor + 'rem, ' + currenPos.y * movementRadius * depthFactor + 'rem, 0) rotate(0.01deg)', 
            transitionDuration: movementDuration + 'ms, 500ms' }">
                <div class="bubble__halo" v-bind:style="getHaloStyles()"></div>
                <div class="bubble__center" v-bind:style="getCenterStyles()"></div>
                <div class="bubble__title">
                    <div 
                        class="bubble__title__container"
                        v-bind:style="getTitleStyles()">
                            <a v-on:click="onClick($event)" class="bubble__title__link">
                                <h2 
                                    class="bubble__title__text"
                                    v-on:mouseover="onMouseOver()"
                                    v-on:mouseleave="onMouseLeave()"
                                    v-html="title">
                                </h2>
                            </a>
                    </div>
                </div>
    </article>
</template>

<style lang="scss" scoped>
.bubble {
    position: absolute;
    width: 39.2rem; height: 39.2rem;
    margin: -19.6rem;
    transition-property: transform, opacity;
    transition-timing-function: easeInOutCubic;
    will-change: transform;
    z-index: 1;
    pointer-events: none;

    @include breakpoint('xs-down') {
        width: 35.2rem; height: 35.2rem;
        margin: -17.6rem
    }
}
.bubble__halo {
    content: "";
    display: block;
    position: absolute;
    width: 100%; height: 100%;
    border-radius: 50%;
    pointer-events: none;
    background: rgba($color-secondary, .27);

    @include breakpoint('xs-down') {
        background: rgba($color-secondary, .12);
    }
}
.bubble--cat-anzeichen .bubble__halo {
    background: rgba($color-purple, .52);

    @include breakpoint('xs-down') {
        background: rgba($color-purple, .25);
    }
}
.bubble--cat-grunde .bubble__halo {
    background: rgba($color-green, .6);

    @include breakpoint('xs-down') {
        background: rgba($color-green, .4);
    }
}
.bubble__center {
    display: block;
    position: absolute;
    left: 50%; top: 50%;
    width: 1.6rem; height: 1.6rem;
    margin: -0.8rem;
    border-radius: 50%;
    background: rgba(white, .75);
    pointer-events: none;
}

.bubble__title {
    position: absolute;
    display: block;
    left: 50%; top: 50%;
    width: 48rem; height: 10.56rem;

    @include breakpoint('xs-down') {
        width: 16.8rem;
    }
}
.bubble__title__container {
    transform-origin: left top;
    padding-left: 2.4rem;
}
.bubble__title__text {
    display: inline;
    margin: 0;
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 1;
    color: $color-primary;
    pointer-events: all;
    cursor: pointer;

    @include breakpoint('xs-down') {
        font-size: 1.76rem;
    }
}
.bubble--large-text .bubble__title__text {
    font-size: 5.2rem;

    @include breakpoint('xs-down') {
        font-size: 2.4rem;
    }
}
.bubble--medium-text .bubble__title__text {
    font-size: 4.4rem;

    @include breakpoint('xs-down') {
        font-size: 2.24rem;
    }
}

.bubble__title__link {
    display: inline-block;
    margin-top: -0.96rem;
    text-decoration: none;
    pointer-events: all;
}
.bubble--large-text .bubble__title__link {
    margin-top: -2.4rem;

    @include breakpoint('xs-down') {
        margin-top: -1.44rem;
    }
}
.bubble--medium-text .bubble__title__link {
    margin-top: -1.76rem;

    @include breakpoint('xs-down') {
        margin-top: -1.12rem;
    }
}
</style>
